import { take, put, select, call, fork } from 'redux-saga/effects';
import { saveAs } from 'file-saver';

import log from 'yeself-client-common/utils/LogUtils';
import { respawn } from 'yeself-client-common/utils/SagaUtils';

import { selectAppId } from 'Console/data/applicationDetail/settings/SettingsSelector';

import { pushNotificationToStack } from 'Console/data/notification/actions';

import {
    fetchRecordingOutputsSuccess,
    fetchRecordingOutputsFail,
    generateRecordingOutputsSuccess,
    generateRecordingOutputsFail,
} from './RecordingAction';

import { downloadRecordingOutputsRequest, generateRecordingOutputsRequest } from './RecordingService';

import { FETCH_RECORDING_OUTPUTS_REQUEST, GENERATE_RECORDING_OUTPUTS_REQUEST } from './types';

function* downloadRecordingOutputsTask(payload) {
    const { addonSystemKey, assetId, guideId, repositoryId, applicationId, message } = payload;
    try {
        const response = yield call(
            downloadRecordingOutputsRequest,
            applicationId,
            addonSystemKey,
            repositoryId,
            assetId
        );

        const [, filename] = response.header['content-disposition'].match(/filename="(.*)"/);
        saveAs(response.body, filename);

        yield put(
            fetchRecordingOutputsSuccess(guideId, assetId, addonSystemKey, repositoryId, message.success)
        );
        yield put(pushNotificationToStack(message.success));
    } catch (err) {
        log.error(err);
        yield put(fetchRecordingOutputsFail());
        yield put(pushNotificationToStack(message.fail));
    }
}

function* downloadRecordingOutputsWatcher() {
    while (true) {
        const { payload } = yield take(FETCH_RECORDING_OUTPUTS_REQUEST);
        yield fork(downloadRecordingOutputsTask, payload);
    }
}

function* generateRecordingOutputsTask(payload) {
    const { message } = payload;
    const recordingId = payload.guideId;

    const applicationId = yield select(selectAppId);

    try {
        yield call(generateRecordingOutputsRequest, applicationId, recordingId);

        yield put(generateRecordingOutputsSuccess(recordingId, message.success));
        yield put(pushNotificationToStack(message.success));
    } catch (err) {
        log.error(err);
        yield put(generateRecordingOutputsFail());
        yield put(pushNotificationToStack(message.fail));
    }
}

function* generateRecordingOutputsWatcher() {
    while (true) {
        const { payload } = yield take(GENERATE_RECORDING_OUTPUTS_REQUEST);
        yield fork(generateRecordingOutputsTask, payload);
    }
}

export default function* recordingSaga() {
    yield respawn(downloadRecordingOutputsWatcher);
    yield respawn(generateRecordingOutputsWatcher);
}
